import { useEffect, useState } from "react";
import { getAllGateways } from "../../../../redux/user/actions";
import { useDispatch, useSelector } from "react-redux";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import { useNavigate } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import DepositImg from "../../../../assets/images/icons/dc.png";
import bankImg from "../../../../assets/images/icons/bank.png";
import { getActiveBankDetails } from "../../../../redux/app/actions";
import LeftArrow from "../../../../assets/images/icons/back.png";
import { Container } from "react-bootstrap";
import LeftBarSports from "../../../components/LeftBarSports";
import WhatsAppWidget from "../../../components/WhatsAppWidget";

import Footer from "../../../../containers/Footer";

import Whatsapp from "../../../../assets/images/Whatsapp.svg";

import Info from "../../../../assets/images/icons/info.png";
import DepositGateway from "./depositGateway";

const GatewaysList = () => {
  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);
  const { bankDetails } = useSelector((state) => state.app);
  const [gatewaysList, setGatewaysList] = useState([]);
  const navigate = useNavigate();
  const [activeGtw, setActiveGtw] = useState(null);

  useEffect(() => {
    loadGtwsFromServer();
    dispatch(getActiveBankDetails());
  }, []);

  const handleGatewayClick = (item) => {
    navigate(`/deposit/${item.id}`);
  };

  const handleBankTransferClick = () => {
    navigate(`/deposit/bank_transfer`);
  };
  const loadGtwsFromServer = async () => {
    const response = await getAllGateways();
    if (response && response?.data?.data?.data) {
      setActiveGtw(response?.data?.data?.data?.deposits?.[0]?.id);
      setGatewaysList(response?.data?.data?.data);
    }
  };
  return (
    <>
      <HeaderAfterLogin />

      <main className="main">
        <div className="main-page">
          <LeftBarSports />

          <div className="main-content">
            <Container fluid>
              <div className="headingSec">
                <div className="back-link" onClick={() => navigate(-1)}>
                  <img src={LeftArrow} alt="LeftArrow" /> <h1>Deposit</h1>{" "}
                </div>
              </div>

              <div className="gatewaySection DepositInnerSection">
                {gatewaysList?.deposits?.length > 1 ? (
                  <div className="gatewaypart">
                    <Tabs
                      defaultActiveKey="Deposit"
                      id="uncontrolled-tab-example"
                      className=""
                    >
                      <Tab
                        eventKey="Deposit"
                        title="Deposit"
                        className="deposit_class"
                      >
                        <div
                          className="gatewaySection"
                          style={{
                            maxWidth: "inherit",
                            margin: "0",
                            width: "100%",
                          }}
                        >
                          <div className="gatewaypart">
                            {/* <Tabs
                        defaultActiveKey="crypto"
                        id="uncontrolled-tab-example"
                        className=""
                      >
                      <Tab
                        eventKey="crypto"
                        title="Crypto"
                        className="deposit_class"
                      > */}

                            {
                              <div className="manual_deposit">
                                <div className="cards">
                                  {bankDetails && (
                                    <div
                                      className="cards1"
                                      onClick={() => {
                                        handleBankTransferClick();
                                      }}
                                    >
                                      {" "}
                                      <div className="card-icon">
                                        <img
                                          src={bankImg}
                                          style={{ width: "66px" }}
                                        />
                                      </div>
                                      <p>{"Bank Transfer"}</p>
                                    </div>
                                  )}

                                  {gatewaysList?.deposits
                                    ?.sort((a, b) => a.order - b.order)
                                    .map((item, index) => {
                                      return (
                                        <div
                                          className="cards1"
                                          onClick={() => {
                                            handleGatewayClick(item);
                                          }}
                                          key={index}
                                        >
                                          <div className="card-icon">
                                            <img
                                              src={item?.logo || DepositImg}
                                            />
                                          </div>
                                          <p>{item?.name}</p>
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            }
                            {/* </Tab>
                      </Tabs> */}
                          </div>
                        </div>
                      </Tab>
                    </Tabs>
                    <p className="DepositContent">
                      <img src={Info} alt="info" /> Deposit Upto 25000 Only !{" "}
                      <img src={Info} alt="info" />
                    </p>
                  </div>
                ) : (
                  activeGtw && <DepositGateway activeGtw={activeGtw} />
                )}
              </div>

              <div className="DepositSection">
                <ul>
                  <h3>BANK ACCOUNT AND QR (UPI)</h3>
                  <li>
                    Please enter the UTR number. Wait 5 minutes after transfer.
                    For issues, contact support.
                  </li>
                </ul>
                <ul>
                  <h3>IN SUPERFAST</h3>
                  <li>
                    No UTR number is needed for payments below ₹2000. Just take
                    a screenshot and complete the payment. For amounts between
                    ₹2000 and ₹25,000, please use another device to scan and
                    pay.
                  </li>
                </ul>
                <h2>For any queries, contact support.</h2>
                <a href="https://api.whatsapp.com/send/?phone=447830739603&text&type=phone_number&app_absent=0">
                  <img src={Whatsapp} alt="Whatsapp"></img>+44 7830739603
                </a>
              </div>
            </Container>

            <Footer />
          </div>
        </div>
      </main>

      {/* <TawkChat /> */}
      <WhatsAppWidget />
    </>
  );
};
export default GatewaysList;
